import React, { FC } from 'react'

import styled, { css } from 'styled-components'

const ArrowWrapper = styled.div`
  // 矢印を囲む要素、矢印の大きさが以下のようになるため固定値で定義
  width: 1.6rem;
  height: 0.8rem;
`
const ArrowBase = css`
  position: absolute;
  bottom: 0;
`
const ArrowUpBg = styled.div`
  ${ArrowBase};
  // 矢印にborderが付いているようにするため、外側に来る要素を1px大きく作る
  border-left: 0.8rem solid transparent;
  border-right: 0.8rem solid transparent;
  //border-bottom: 0.8rem solid;
  z-index: 7;
`
const ArrowUp = styled.div`
  ${ArrowBase};
  border-left: 0.7rem solid transparent;
  border-right: 0.7rem solid transparent;
  //border-bottom: 0.7rem solid;
  z-index: 8;
  left: 0.1rem;
`

type Props = {
  className?: string
}

export const RangeDateDropdownArrow: FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <ArrowWrapper>
        <ArrowUpBg className="tw-border-b-[0.8rem] border-b-solid tw-border-b-background-secondary" />
        <ArrowUp className="tw-border-b-[0.7rem] border-b-solid  tw-border-b-background-secondary" />
      </ArrowWrapper>
    </div>
  )
}
